import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PhysicianService} from '../service/physician.service';
import { saveAs } from 'file-saver'
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {AppointmentTransactionComponent} from '../../appointment/appointment-transaction/appointment-transaction.component';
import {MatDialog} from '@angular/material';
import {PhysicianDocumentViewComponent} from '../physician-document-view/physician-document-view.component';

@Component({
  selector: 'app-physician-details',
  templateUrl: './physician-details.component.html',
  styleUrls: ['./physician-details.component.css']
})
export class PhysicianDetailsComponent implements OnInit {

  physicianId: any;
  physican:any;
  // comment:any;
physicianStatusForm: FormGroup;
physicianComment : FormControl = new FormControl();



    constructor(private _route: ActivatedRoute,private router: Router,
                private _formBuilder: FormBuilder,
                private toastr: ToastrService,
                public dialog: MatDialog,
              private physicianService: PhysicianService) {
      this._route.params.subscribe(routeParams => {
        this.physicianId = routeParams.physicianId
      });

  }

  ngOnInit() {
    this.physicianService.getPhysicianById(this.physicianId).subscribe(data=>{
        this.physican = data.json();
    })
      this.physicianStatusForm = this. _formBuilder.group({
          comment: [''],
          status: ['', Validators.required],
          physicianId: [this.physicianId, Validators.required],
      });
  }

    downloadFile(data, headers, isZip) {
        /*const file = new Blob([ data ], {
            type : headers.get('Content-Type') || (isZip ? 'application/zip;charset=utf-8' : 'image/jpeg;charset=utf-8')
        });
        const contentd = headers.get('Content-Disposition');
        let filename = headers.get('x-filename') || (isZip ? 'export-multiple.zip' : 'export-multiple.jpeg');
        if (contentd.indexOf('filename="') > 0) {
            filename = contentd.substr(contentd.indexOf('filename="') + 10);
            filename = filename.substr(0, filename.length - 1);
        }
        const fileURL = URL.createObjectURL(file);
        const a         = document.createElement('a');
        a.href        = fileURL;
        a.target      = '_blank';
        //a.visibility 	  = 'visibility:hidden';
        a.download    = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);*/

        this.dialog.open(PhysicianDocumentViewComponent, {
            data: {data:data},
            height: '800px',
            width: '800px',
        });
        /*let file = new Blob([data], {type: "image/jpeg"});
        saveAs(file,'doc1.jpeg');*/

    }

    goBackToPhy(){
        this.router.navigate( [ '/elasticcare/physician' ,{} ]);
    }

    activatePhy(status){
        this.physicianStatusForm.controls['status'].setValue(status);
        // this.physicianStatusForm.controls['comment'].setValue(this.comment);

      if(!this.physicianStatusForm.valid) {
          return
      } else
      {
          // this.physicianStatusForm.controls['status'].setValue(status);
          this.physicianService.updatePhysicianStatus(this.physicianStatusForm.value)
              .subscribe(data => {
                  this.toastr.success('', 'Physician Status Updated Successfully');
                  this.goBackToPhy();
              }, (error) => {
                  const  errorResponse = JSON.parse(error._body);
                  if (errorResponse.message !== undefined && errorResponse.message !== null) {
                      this.toastr.error('', errorResponse.message);
                  } else {
                      this.toastr.error('', 'Please try again');
                  }
          });
      }
    }

}
